import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { EditCommentComponent } from '../../alerts/comments/edit-comment/edit-comment.component';

@Component({
  selector: 'app-comments-grid',
  templateUrl: './comments-grid.component.html',
  styleUrls: ['./comments-grid.component.scss']
})
export class CommentsGridComponent implements OnInit {
  @Input() activeArrData;
  @Input() inactiveArrData;
  @Input() mantenienceSection;
  @Output() editedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() deletedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() statusField: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private serviceModal: NgbModal,
  ) { }

  ngOnInit(): void { }

  delete(comment) {
    Swal.fire({
      title: `¿Desea eliminar <br> <b>${comment.title}</b>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deletedData.emit(comment.id);
      }
    });
  }

  editComment(comment) {
    const modal = this.serviceModal.open(EditCommentComponent, {
      centered: true,
      windowClass: 'custom-modal-benefit d-flex flex-column w-100 justify-content-center h-75pr'
    });
    modal.componentInstance.commentInfo = comment;
    modal.result.then((res) => {
      this.editedData.emit(res);
    }, (reason) => {
      
    });
  }

  changeStatus(comment: any, currentStatus: string) {
    Swal.fire({
      title: `${currentStatus === 'Desactivado' ? 'Habilitando' : 'Deshabilitando'} ${comment.title}...`,
      text: 'Por favor espere',
      icon: 'warning',
      backdrop: false,
    });
    Swal.showLoading();
    this.statusField.emit({
      id: comment.id
    });
  }
}
